
import Vue from "vue";
import Component from "vue-class-component";
import VueMarkdown from "vue-markdown";

@Component({
  components: { "vue-markdown": VueMarkdown },
  filters: {},
})
export default class ENASearchAboutBox extends Vue {}
